import { useState } from "react";
import { Eye, EyeOff } from "lucide-react";

export const PasswordInput = ({ className = "", type, ...props }) => {
  const [show, setShow] = useState(false);
  const testid = props["data-testid"] || "password";
  return (
    <div className="relative">
      <input {...props} type={show ? "text" : "password"} className={`${className} pr-12`} />
      <button type="button" onClick={() => setShow(!show)} aria-label={show ? "Nascondi password" : "Mostra password"} aria-pressed={show}
        title={show ? "Nascondi password" : "Mostra password"} data-testid={`${testid}-toggle`}
        className="absolute inset-y-0 right-0 flex w-11 items-center justify-center text-stone-500 transition-colors hover:text-black">
        {show ? <EyeOff className="h-4 w-4" /> : <Eye className="h-4 w-4" />}
      </button>
    </div>
  );
};
